// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import error from '../../../../common/nodejs/errors';
import config from '../../../../share/config';
import loading from '../../../../share/components/vue/ProcessingIcon';
import { mapState } from 'vuex';
import logWrapper from '../../../../share/logWrapper';
import eventLogUtil from '../../../../share/util/eventLogUtil';
import util from '../../../../share/util/utils';

export default {

  data() {
    return {
      modelUpdateProcessing: true,
      turnIgOnChecked: false,
      processing: false,

      // 各種ダイアログの変数
      registerimbsystype2startregconfirm: false,
      registerimbsystype2confirmigonwithgivenkey: false,
      registerimbsystype2confirmigonwithexistingkey: false,
      registerimbsystypeeconfirmigonwithexistingkey: false,
      registerimbsystype2warningignoton: false,
      registerimbsystype2confirmigonrequired: false,
      registerimbsystype2processisongoingcomBIU: false,
      registerimbsyseonlyprocessisongoing: false,
      registerimbsystype2confirmkeyidentificationestablish: false,
      registerimbsystype2confirmkeyalreadyregistered: false,
      registerimbsystype2confirmmaxnoofregisteredkeys: false,
      registerimbsystype2confirmkeyhasbeenregistered: false,
      registerimbsystype2processisongoingconfirmkeyidentification: false,
      registerimbsystype2confirmkeyhasalreadybeenread: false,
      registerimbsystype2confirmkeyconfirmed: false,
      registerimbsystype2success: false,
      registerimbsystype2failure: false,
      modalregisterimmobilizertype2warning: false,
      registerimbsystype2confirmigisoff: false,
      nextModalId: null
    };
  },

  props: {
    startRegType2OnConfirmOkButtonclick: Function,
    imbRegImbSysType2confirmOKOrRetryButtonClick: Function,
    callEndOfKeyRegOnOkButtonClick: Function,
    onErrornotifyEndOfProcessRegImbSys: Function,
    backEventOnCancleButtonClick: Function,
    imbStatusInfo: Object,
    onSetEndOfProcessingFlag: Function,
    isCausesAndActionDialog: Function,
    changeProcessingStatus: Function,
    modalShowInfo: {
      type: Object,
      require: false,
      default: () => ({ id: "", isShow: false }),
    },
  },

  components: {
    'processing-view': loading,
  },

  computed: {
    ...mapState({
      isNorthAmerica: state => state.userProperty.region === config.REGION_NORTH_AMERICA,
      vehicle: state => state.vehicle,
      netAppId: state => state.netAppConnector.pairingAppId
    }),
  },

  watch: {
    processing: function (value) {
      this.changeProcessingStatus(value);
    },
    modalShowInfo: {
      handler(value) {
        if (value) {
          const id = value.id.replace(/-/g, "");
          if (util.hasPropertyCheck(this, id)) {
            this[id] = value.isShow;
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    successOkButtonClick: function () {
      this.dialogCloseProcess();
      this.nextModalId = 'register-imb-sys-type-2-confirm-ig-is-off';
    },
    igOffOkButtonClick: function () {
      this.dialogCloseProcess();
      this.turnIgOnChecked = false;
      this.determineEndOfProcessingFlag();
    },
    igOnOkOrRetryButtonClick: async function (id) {
      await this.imbRegImbSysType2confirmOKOrRetryButtonClick(id);
      this.turnIgOnChecked = false;
    },
    igOnCancelButtonClick: async function () {
      this.processing = true;
      await this.backEventOnCancleButtonClick();
      eventLogUtil.updateImbEventLogCanceled(this.netAppId);
      this.processing = false;
      this.turnIgOnChecked = false;
      this.determineEndOfProcessingFlag();
    },
    errorOkButtonClick: async function () {
      this.processing = true;
      await this.onErrornotifyEndOfProcessRegImbSys();
      this.processing = false;
      if (this.imbStatusInfo.error_code === error.IMB_NUM_OF_REGISTERED_KEYS_EXCEEDED) {
        this.determineEndOfProcessingFlag();
      }
    },
    backEventButtonClick: async function () {
      this.processing = true;
      await this.backEventOnCancleButtonClick();
      this.processing = false;
      this.determineEndOfProcessingFlag();
    },
    cancelButtonClick: function () {
      this.dialogCloseProcess();
      this.determineEndOfProcessingFlag();
    },
    determineEndOfProcessingFlag: function () {
      if (this.vehicle.vehicleInfo === null) {
        logWrapper.log('vehicle information is ', this.vehicle.vehicleInfo);
        this.onSetEndOfProcessingFlag();
      }
    },
    modalShowWEvent: function (mode) {
      const info = { id: this.modalShowInfo.id, isShow: false, nextModal: this.modalShowInfo.nextModal };
      if (mode === "show") {
        info.isShow = true;
      } else {
        // 次のダイアログが設定されていた場合のみ
        if (this.nextModalId) {
          info.nextModal = { id: this.nextModalId, msg: "" };
          this.nextModalId = null;
        }
      }
      this.$emit("modalDisplayStatus", info);
    },

    dialogCloseProcess: function () {
      const id = this.modalShowInfo.id.replace(/-/g, "");
      if (util.hasPropertyCheck(this, id)) {
        this[id] = false;
      }
    }

  },

  created() { },

};